import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { base_url } from '../../Api/Api';
import { Loader } from '../../Global/Loader';
import Button from '@material-ui/core/Button';

import Header from '../../Global/Header';
import ItemWebinar from './itemWebinar';

const WebinarDetailes = (props) => {

    const [state, setState] = useState({
        data: [],
        loader: true
    })

    useEffect(() => {


        base_url.get(`webinar/${props.match.params.id}`)
            .then(response => {
                console.log(response.data, 'response')
                setState({
                    ...state,
                    data: response.data,
                    loader: false
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    console.log(error)
                    if (error.response.status == 401) {
                        localStorage.clear()
                        props.history.push(`/Entrance`)
                        window.location.reload()
                    }
                }
            })

    }, [])

    return (
        <div className="instructpg webinars-detailes">
            <Loader
                active={state.loader} />
            <Header
                innerPage={true}
                title={'جزییات وبینار'} />
            <div className="body-webinar">

                {state.data.length == 0 ?
                    null
                    :
                    <div className="item-webinarses details">
                        <div className="pic">
                            <img src={state.data.original_image} />
                        </div>
                        <h4>
                            {state.data.title}
                            <span>
                                {state.data.score}
                                <i className="icon-black-star-silhouette"></i>
                            </span>
                        </h4>
                        <div className="date">
                            <div className="date-details">
                                <span>تاریخ شروع : </span>
                                <strong>{state.data.string_starttime}</strong>
                            </div>
                            <div className="date-details">
                                <span>زمان برگزاری : </span>
                                <strong>{state.data.string_eventtime}</strong>
                            </div>
                            <div className="date-details">
                                <span>تاریخ پایان : </span>
                                <strong>{state.data.string_enddate}</strong>
                            </div>
                            <div className="date-details">
                                <span>زمان پایان : </span>
                                <strong>{state.data.string_endtime}</strong>
                            </div>
                        </div>
                        <div className="date-details">
                            <span>درباره وبینار :</span>
                            <strong>{state.data.description}</strong>
                        </div>
                        <div className="list-tags gray">
                            {state.data.tags.map(item =>
                                <span>{item.name}</span>
                            )}
                        </div>

                        <div className="btn-base btn-black btn-sircle">
                            <a href={state.data.url}>
                                <Button
                                    variant="contained" >
                                    ورود به کلاس
                                </Button>
                            </a>
                        </div>

                    </div>
                }

            </div>
        </div>
    );
}

export default WebinarDetailes;